import { Component, OnInit, HostListener, ElementRef, Renderer2, Directive } from '@angular/core';

@Directive({
  selector: "[uFixTop]"
})
export class UserFixTop {
  public old_top: number;
  constructor(
    public ctop: ElementRef,
    private renderer: Renderer2,
  ) {
    this.old_top = this.ctop.nativeElement.offsetTop;
  }
  @HostListener("document:scroll", ["$event"]) mouseWheel(event: any) {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    console.log("top:", scrollTop);

    if (scrollTop >= 240) {
      console.log("11111");
      this.renderer.setStyle(this.ctop.nativeElement, "top", "0px");
    } else {
      this.renderer.setStyle(this.ctop.nativeElement, "top", "-60px");
    }

  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/detail/user-fix-top.component.ts